import React from "react";
import { Card } from "@mui/material";
import ProductCatalogList from "./ProductCatalogList";

const ProductList = ({ isReadOnly }) => {
  return (
    <>
        <Card sx={{ p: 2 }}>
            <ProductCatalogList isReadOnly={isReadOnly} />
        </Card>
    </>
  );
};

export default ProductList;